import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, Box, Button, CircularProgress, Container, LinearProgress, Snackbar, Typography, useMediaQuery, useTheme } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../styles/StylesConstantes";
import ActivacionAddComponents from "../../../components/ActivacionAddComponents";
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';


function AddActivacionesPage() {
    const [cargando, setCargando] = useState(false);
    const [titulo, setTitulo] = useState('');
    const [imagen, setImagen] = useState('');
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaInicioBackend, setFechaInicioBackend] = useState('');
    const [horaInicio, setHoraInicio] = useState(dayjs().hour(0).minute(0));
    const [horaInicioBackend, setHoraInicioBackend] = useState('');
    const [fechaFin, setFechaFin] = useState(null);
    const [fechaFinBackend, setFechaFinBackend] = useState('');
    const [horaFin, setHoraFin] = useState(dayjs().hour(0).minute(0));
    const [horaFinBackend, setHoraFinBackend] = useState('');

    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));

    const navigate = useNavigate();

    // console.log("info data", id);

    useEffect(() => {
        // handleListarProductos();
        setTimeout(() => {
            setCargando(true);
        }, 1000);
    }, []);




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    //=========================================================funcion para cancelar y volver a la lista
    const handleCancelar = () => {
        window.history.back();
    };

    //=========================================================funcion para guardar
    const handleGuardar = () => {
        let body = {};
        body.nombre = titulo;
        body.imagen = imagen;

        console.log("body", body);

        //validar campos que no esten vacios
        if (titulo.trim() === '' || imagen === '' || fechaInicioBackend === '' || horaInicioBackend === '' || fechaFinBackend === '' || horaFinBackend === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('Todos los campos son obligatorios');
        } else {

            setLoadingGuardar(true);


            setTimeout(() => {
                setLoadingGuardar(false);

                setTimeout(() => {
                    setOpen(true);
                    setSeverity('success');
                    setMensaje('Guardado con exito');

                    setTimeout(() => {
                        navigate('/app/admin/activaciones');
                    }, 1000);
                }, 1000);

            }, 2000);
        }
    };

    //=========================================================funcion para agregar imagen
    const handleAgregarImagen = (event) => {
        const file = event.target.files[0];
        console.log("file", file);

        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setImagen(e.target.result);
            };
            reader.readAsDataURL
                (file);
        }

    };

    //=============================================funcion para seleccionar la fecha inicio
    const handleFechaInicio = (event) => {
        // console.log("event", event);
        setFechaInicio(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        setFechaInicioBackend(fecha);
    };

    //=============================================funcion para seleccionar la hora inicio
    const handleHoraInicio = (event) => {
        setHoraInicio(event);

        //formato de 24 horas
        let hora = event.format('HH:mm:ss');
        setHoraInicioBackend(hora);
    }

    //=============================================funcion para seleccionar la fecha fin
    const handleFechaFin = (event) => {
        console.log("event", event);
        setFechaFin(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        console.log("fecha", fecha);
        setFechaFinBackend(fecha);
    };

    //=============================================funcion para seleccionar la hora fin
    const handleHoraFin = (event) => {
        setHoraFin(event);

        //formato de 24 horas
        let hora = event.format('HH:mm:ss');
        setHoraFinBackend(hora);
    };


    return (
        <HeaderCustom>
            <div style={{
                marginTop: Padding.P2,
                padding: Padding.P2,
            }}>

                <div style={{
                    backgroundColor: PaletaColor.BLANCO,
                    borderRadius: Padding.P1,
                    padding: Padding.P3,
                }}>
                    {cargando ? (
                        <div style={{}}>
                            <Typography variant={'h5'} style={{ marginBottom: Padding.P2 }}>
                                Crear Activación
                            </Typography>

                            <ActivacionAddComponents
                                mobile={mobile}
                                titulo={titulo}
                                setTitulo={setTitulo}
                                imagen={imagen}
                                setImagen={setImagen}
                                handleCancelar={handleCancelar}
                                handleGuardar={handleGuardar}
                                handleAgregarImagen={handleAgregarImagen}
                                fechaInicio={fechaInicio}
                                handleFechaInicio={handleFechaInicio}
                                fechaFin={fechaFin}
                                handleFechaFin={handleFechaFin}
                                horaInicio={horaInicio}
                                handleHoraInicio={handleHoraInicio}
                                horaFin={horaFin}
                                handleHoraFin={handleHoraFin}

                            />
                        </div>
                    ) : <SkeletonLoading />
                    }
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default AddActivacionesPage;